import { render, staticRenderFns } from "./ProductReviewCard.vue?vue&type=template&id=0196ff18&scoped=true&"
import script from "./ProductReviewCard.vue?vue&type=script&lang=js&"
export * from "./ProductReviewCard.vue?vue&type=script&lang=js&"
import style0 from "./ProductReviewCard.vue?vue&type=style&index=0&id=0196ff18&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0196ff18",
  null
  
)

export default component.exports